//
//
//
//
//
//
//
//
//
//

import CommonList from "@/components/nav_common/CommonList.vue";
import { Author, Collection, Quote } from "@/models";

export default {
  data() {
    return {
      // 确定哪一个被选中
      searchSelect: {
        dynasty: null,
        kind: null,
        // 存放authorId
        author: null,
        // 存放collectionId
        collection: null
      },
      conditions: [
        {
          name: "朝代",
          type: "dynasty",
          list: [
            { text: "先秦" },
            { text: "秦" },
            { text: "汉" },
            { text: "三国" },
            { text: "晋" },
            { text: "南北朝" },
            { text: "隋" },
            { text: "唐" },
            { text: "五代" },
            { text: "宋" },
            { text: "金" },
            { text: "元" },
            { text: "明" },
            { text: "清" },
            { text: "现代" }
          ]
        },
        {
          name: "体裁",
          type: "kind",
          list: [
            { kind: "shi", text: "诗" },
            { kind: "ci", text: "词" },
            { kind: "fu", text: "曲" },
            { kind: "wen", text: "文言文" }
          ]
        }
      ]
    };
  },

  props: {
    page: {
      type: Number,
      default: 1
    },
    perPage: {
      type: Number,
      default: 10
    }
  },

  watch: {
    page: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.getQuotes();
        }
      },
      immediate: false
    }
  },

  created() {
    let promises = [];

    // 向data的condition里添加作者
    promises.push(
      Author.getHotAuthors().then(result => {
        // 截取数据存入data
        let authorCondition = { name: "作者", list: [], type: "author" };
        let { list } = authorCondition;

        result.forEach(author => {
          list.push({
            check: false,
            text: author.get("name"),
            authorId: author.id
          });
        });

        this.conditions.unshift(authorCondition);
      })
    );

    // 向data的condition里添加分类
    promises.push(
      Collection.getPartCollections().then(result => {
        let collectCondition = { name: "分类", list: [], type: "collection" };
        let { list } = collectCondition;

        // 限制分类条目数位30条
        for (let i = 0; i < 30; i++) {
          let collection = result[i];

          list.push({
            text: collection.get("name"),
            collectionId: collection.id
          });
        }

        this.conditions.unshift(collectCondition);
      })
    );

    this.getQuotes();
  },

  methods: {
    getQuotes() {
      // 查询满足所有搜索条件的Quote
      // page 默认 1, perPage 默认 10
      Quote.getQuotesIncludeCount(
        {
          authorId: this.searchSelect.author,
          collectionId: this.searchSelect.collection,
          kind: this.searchSelect.kind,
          dynasty: this.searchSelect.dynasty
        },
        this.page,
        this.perPage
      ).then(result => {
        this.$emit("get-quote-data", result.quotes);
        this.$emit("get-count", result.pageCount);
      });
    },

    clickDynasty(dynasty) {
      if (dynasty === "五代") {
        this.searchSelect.dynasty = "五代十国";
      } else if (dynasty === "先秦") {
        this.searchSelect.dynasty = "周";
      } else {
        this.searchSelect.dynasty = dynasty;
      }
    },

    clickCondition(data, type) {
      // 根据type判断 选择了哪些
      switch (type) {
        case "dynasty":
          this.clickDynasty(data.text);
          break;
        case "author":
          this.searchSelect.author = data.authorId;
          break;
        case "collection":
          this.searchSelect.collection = data.collectionId;
          break;
        case "kind":
          this.searchSelect.kind = data.kind;
          break;
      }
      this.$emit("change-page", 1);

      this.getQuotes();
    },

    // 如果点击了 “不限” 那么设置搜索选项为空
    clickUnlimit(type) {
      this.$emit("change-page", 1);
      this.searchSelect[type] = null;
      this.getQuotes();
    }
  },

  components: {
    CommonList
  }
};



// WEBPACK FOOTER //
// ./src/components/nav_quote/QuoteClassList.vue